export default (that) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_doc_operation") || "操作",
    headerAlign: "center",
    align: "center",
    fixed: "left",
    width: 110,
    slots: {
      default: "opt",
    },
  },
  {
    title: that.$l("INDEX.table_label_doc_docType") || "文档类型",
    field: "docTypeText",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_doc_fileName") || "文件名",
    field: "fileName",
    minWidth: 230,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_doc_remark") || "文档说明",
    field: "remark",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_doc_fileStatus") || "状态",
    field: "fileStatus",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "fileStatus" },
  },
  {
    title: that.$l("INDEX.table_label_doc_createByName") || "上传人",
    field: "createByName",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "displayCreateBy" },
  },
];
